import React from 'react';
import { TextBlock } from '@thd-olt-component-react/loading-placeholder';

export const EtchPlaceholder = () => (
  <TextBlock color="#E0E0E0" rows={12} />
);
